<template>
  <div class="page page-with-bg page-cancelable">
    <div class="page-form-wrap">
      <div class="page-form-cancel">
        <b-btn 
          class="page-cancel-button" 
          variant="link" 
          type="submit" 
          to="/employees"
        >
          <svg-icon name="close" /> Cancel
        </b-btn>
      </div>
      <div class="page-form-header">
        <h1>Add Team Member</h1>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">
          <validation-summary :errors="errors"></validation-summary>
          <div class="row">
            <v-form-group 
              class="col-12 col-md-6" 
              :validator="$v.firstName" 
              label="First Name"
            >
              <b-form-input 
                v-model="firstName"
                placeholder="First Name"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners" 
              />
            </v-form-group>
            <v-form-group 
              class="col-12 col-md-6" 
              :validator="$v.lastName" 
              label="Last Name"
            >
              <b-form-input 
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
                v-model="lastName"
                placeholder="Last Name" 
              />
            </v-form-group>
          </div>
          <v-form-group 
            :validator="$v.email" 
            label="Email"
          >
            <b-form-input 
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              v-model="email"
              placeholder="Email" 
            />
          </v-form-group>
          <v-form-group 
            :validator="$v.npi" 
            label="NPI"
            v-if="providerSelected"
          >
            <b-form-input 
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              v-model="npi"
              placeholder="NPI" 
            />
          </v-form-group>
          <alert-message v-if="showNpiAlertMessage" :message="npiAlertMessage" alert-type="warning"></alert-message>
          <b-form-group class="form-group-radio" :validator="$v.roleId" label="Permission Level">
            <b-form-radio v-model="roleId" name="permissions" :value="role.Client">
              <div>Client Admin</div>
              <ul>
                <li>Add Users</li>
                <li>Assign Permissions</li>
              </ul>
            </b-form-radio>
            <b-form-radio v-model="roleId" name="permissions" :value="role.ClientUser">
              <div>Full User</div>
              <ul>
                <li>Create New Orders</li>
                <li>Search/View/Download All Orders</li>
              </ul>
            </b-form-radio>
            <b-form-radio v-model="roleId" name="permissions" :value="role.ClientOrderer">
              <div>Order Only</div>
              <ul>
                <li>Search and Create Orders</li>
              </ul>
            </b-form-radio>
            <b-form-radio v-model="roleId" name="permissions" :value="role.ClientProvider">
              <div>Provider</div>
              <ul>
                <li>Add Users</li>
                <li>Assign Permissions</li>
              </ul>
            </b-form-radio>
          </b-form-group>
          <b-form-group class="form-buttons">
            <b-btn variant="success" type="submit">Add Team Member</b-btn>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, email, alphaNum } from "vuelidate/lib/validators";
  import formMixin from "mixins/form-mixin";
  import employeeService from "services/employee-service";
  import role from "enums/role.js";
  import AlertMessage from 'components/common/alert-message';

  export default {
    mixins: [formMixin],

    components: {
      AlertMessage
    },

    data() {
      return {
        firstName: "",
        lastName: "",
        email: "",
        npi: "",
        roleId: role.Client,
        role: role,
        showNpiAlertMessage: false,
        npiAlertMessage: "Are you sure that you do not want to enter the Provider’s NPI? This is necessary to associate orders with them."
      };
    },

    validations: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required,
        email
      },
      npi: {
        alphaNum
      },
      roleId: {
        required
      }
    },

    computed: {
      providerSelected() {
        return this.roleId === role.ClientProvider;
      },
      clientId() {
        return this.$route.query.clientId;
      }
    },

    watch: {
      roleId() {
        this.showNpiAlertMessage = false;
      }
    },

    methods: {
      async onSubmit() {
        if (!this.creationAllowed())
          return;

        let data = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          physicianNPI: this.npi,
          roleId: this.roleId,
          clientId: this.clientId
        };

        await employeeService.create(data);
        this.$root.successToast("Team member invited!");
        this.$router.push({ path: "/employees", query: { clientId: this.clientId } });
      },

      creationAllowed() {
        if (!this.providerSelected || this.showNpiAlertMessage)
          return true;

        this.showNpiAlertMessage = this.providerSelected && !this.npi.length;

        return !this.showNpiAlertMessage;
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/doctor.png');
  }
</style>